class SizeGuideCalculator extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.showTab(tab.dataset.tabTrigger));
    });

    this.unitButtons = Array.from(this.querySelectorAll('[data-unit-trigger]'));
    this.unitButtons.forEach((button) => {
      button.addEventListener('click', () => this.showUnit(button.dataset.unitTrigger));
    });

    this.calcInput = this.querySelector('[data-calc-input]');
    this.calcResult = this.querySelector('[data-calc-result]');
    const sizesJson = this.querySelector('[data-calculator-sizes]');
    if (this.calcInput && sizesJson) {
      this.sizes = JSON.parse(sizesJson.textContent);
      this.calcInput.addEventListener('input', () => this.calculate());
    }
  }

  showTab(id) {
    this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.tabTrigger === id));
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== id;
    });
  }

  showUnit(unit) {
    this.unitButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.unitTrigger === unit);
    });
    this.querySelectorAll('[data-size-eu]').forEach((el) => {
      el.hidden = unit !== 'EU';
    });
    this.querySelectorAll('[data-size-us]').forEach((el) => {
      el.hidden = unit !== 'US';
    });
  }

  calculate() {
    if (!this.calcResult) return;
    const raw = this.calcInput.value.replace(',', '.');
    const value = parseFloat(raw);
    if (!value || value <= 0) {
      this.calcResult.textContent = this.calcResult.dataset.emptyText;
      this.calcResult.classList.add('size-guide__calc-result--muted');
      return;
    }
    const match = this.sizes.find((size) => value <= size.foot);
    this.calcResult.classList.remove('size-guide__calc-result--muted');
    if (!match) {
      this.calcResult.textContent = this.calcResult.dataset.outOfRangeText;
      return;
    }
    this.calcResult.innerHTML = `${this.calcResult.dataset.resultText} <strong>EU ${match.eu} · US ${match.us}</strong>`;
  }
}

customElements.define('size-guide-calculator', SizeGuideCalculator);
